<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

  <div class=" mb-5" >
      <!-- <h4 class="manage-boder">Manage Customer</h4>  -->
      <h6 class="manage-boder pt-2 font1  decoration"> <a class="decoration" to="/"> Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Product Sales </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Product GIN </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Manage Consignment GIN  </h6>
 
      <div class="container-fluid">
      <div style="border: 0px; padding: 0px; min-height:0px" class="navbar">

        <div class="d-flex">
          <b-input-group size="sm" style="width: 225px;">
            <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Search">
            </b-form-input>
            
    </b-input-group>
    <div style="margin-top: 11px;" class="ms-2" >
    <span class="custom-breadcrumb"><b>Showing {{currentPage}}-{{currentPage*perPage}} of {{totalRows}} items.</b></span>
  </div>

        </div>


<div class="d-grid gap-2 d-md-flex justify-content-md-end">


<!-- <button  @click="squatationCreate()"  class="btn btn-outline-primary btn-sm mb-1 mt-1">  Create Quotations</button> -->


<div>
<b-modal :id="infoModal1.id" 
:header-bg-variant="headerBgVariant"
:header-text-variant="headerTextVariant"

bottom>
<template   #modal-title>

<h3 >Confirm !</h3>



</template>

<div class="d-block text-center">
<h5>Are you sure you want to Confirm this item?</h5>
</div>
<hr>

<template   #modal-footer>
<button style="font-size: small;" @click="Confirm(infoModal1.content)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">Yes</button>
<button style="font-size: small;" @click="$bvModal.hide(infoModal1.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">No</button>
</template>


</b-modal>


</div>

</div>
</div>



<div class="card mt-1 ">
<div class="card-body ">

  <div class="d-flex justify-content-center" v-if="isLoading">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
<div v-else>
  <!-- <div style="border: 0px; padding: 0px; min-height:20px" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
      <span class="custom-breadcrumb"><b>Showing {{currentPage}}-{{currentPage*perPage}} of {{totalRows}} items.</b></span>
    </div>
    </div> -->

  <b-table responsive style="font-size: small;"  class="table-hover  "
      :items="igins"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
    
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      
      
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
  
      show-empty
      small
      @filtered="onFiltered"
    >
   


      <template #cell(name)="row">
        {{ row.value.first }} {{ row.value.last }}
      </template>
      <template #cell(number)="row">
        {{ row.index + 1 === 10 ? currentPage * 10 : currentPage - 1 + row.index + 1 }}
       
        
      </template>

      <template #cell(actions)="row">
        <!-- <button class="btn mr-1 custom-btn btn-primary btn-sm mb-1 font-size_def" @click="row.toggleDetails">
          {{ row.detailsShowing ? 'Hide' : 'Show' }} 
        </button> -->
        <!-- <b-button style="background-color: rgb(71, 144, 255);"  size="sm"  class="mr-1 custom-btn">
          View
        </b-button> -->
        <!-- <button style="font-size: small;" 
         @click="info(row.item.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1 ">
          View
        </button> -->
        <button  style=" font-size: small;"
         @click="Viewpage(row.item.id)" class="mr-1 btn   btn-outline-primary btn-sm mb-1 bdr-rad">
          View
        </button>
        <button  style=" font-size: small;"
         @click="Createinvoice(row.item.id)" v-if="row.item.statusvalue==3" class="mr-1 btn  btn-outline-primary btn-sm mb-1 bdr-rad">
         Create Invoice
        </button>
        <button style="font-size: small;"   v-show="row.item.statusvalue==3"   class="mr-1 btn btn-outline-primary btn-sm mb-1 font-size_def bdr-rad">
          Print
        </button>
        <button @click="updateLoad(row.item.id)" v-show="row.item.statusvalue==1" size="sm"  class="btn mr-1 btn btn-outline-primary btn-sm mb-1 font-size_def bdr-rad">
          Update
        </button>

        <button style="font-size: small;"  @click="Confimmodel(row.item.id)"  v-show="row.item.statusvalue==1" size="sm"  class="mr-1 btn btn-outline-primary btn-sm mb-1 font-size_def bdr-rad">
          Confirm
        </button>
        <button  v-show="row.item.statusvalue==1" size="sm"  class="mr-1 btn btn-outline-primary btn-sm mb-1 font-size_def bdr-rad">
          Cancel
        </button>
        <button v-show="row.item.statusvalue!=1"  @click="generatePDF(row.item.id)"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Print</button>
       
      </template>

      <template #row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template>
    </b-table>



    <!-- model start -->
    <b-modal   :id="infoModal.id" :title="infoModal.content.SI_issueNum"  hide-footer >
<div class=" ">
<div class="card">
  <div class="card-body">
      <table style="font-size: small; " class="table  table-sm  ">
       
       <tbody >

         <tr >
           <td style="border: 0px;" ><b>Id </b></td>
          <td style="border: 0px;">{{ infoModal.content.idStockIssue }}</td> 
         </tr>
         <tr>
           <td><b>Issue No. </b></td>
          <td>{{ infoModal.content.SI_issueNum }}</td> 
         </tr>
         <tr>
           <td><b>Issued to </b></td>
          <td>{{ infoModal.content.end_user }}</td> 
         </tr>
        
         <tr>
           <td><b>Issued Date </b></td>
          <td>{{ infoModal.content.issues_date }}</td> 
         </tr>
         <tr>
           <td><b>Created Date </b></td>
          <td>{{ infoModal.content.SI_created_date }}</td> 
         </tr>
         <tr>
           <td><b>Remarks </b></td>
          <td>{{ infoModal.content.SI_remarks }}</td> 
         </tr>
         <tr>
           <td><b>Status </b></td>
          <td>{{ infoModal.content.status }}</td> 
         </tr>
        
          
       </tbody>


     </table>

<div   class="d-grid gap-2 d-md-flex justify-content-md-end mb-2">
<button  v-on:click="ViewLoad(infoModal.content.idStockIssue)"   class=" btn custom-btn btn-primary btn-sm mb-1 bdr-rad"> More</button>
</div>
</div>
</div>
</div>  
      
    </b-modal>

    <!-- model end -->
    
      <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-5">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>

      

    </div>
    
    

  

</div>
</div>
</div>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
    import jsPDF from 'jspdf';
   import 'jspdf-autotable';
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        isLoading: true, 
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        alldata:{},
        all_code:{},
        details:[],
        total:{},
        filterOn: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
       
        igins:[],
       
        fields: [
          { key: 'number', label: '#', sortable: true, sortDirection: 'desc' },
          { key: 'brand_name', label: 'Brand', sortable: true,  },
          { key: 'SI_issueNum', label: 'GIN No.', sortable: true, sortDirection: 'desc' },
          { key: 'SI_type', label: 'GIN Type', sortable: true,  },
          { key: 'issues_date', label: 'Issued Date', sortable: true  },
          { key: 'C_name', label: 'Customer', sortable: true  },
          { key: 'sales_name', label: 'Sales Person', sortable: true  },
          { key: 'SI_created_date', label: 'Created Date', sortable: true  },
          { key: 'status', label: 'Status', sortable: true  },
          
          { key: 'actions', label: 'Actions', class:'width-custom7', }
        ],

        infoModal: {
          id: 'info-modal',
          title: '',
          content: {},
        },
        infoModal1: {
          id: 'info-modal1',
          title: '',
          content: {},
        },
        variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark','mycoolor'],
        headerBgVariant: 'mycoolor',
        headerTextVariant: 'light',
      


        
      }

    },
    computed: {
     
    },
    mounted(){
     
      
  this.loadGin();


    },
methods : {


  async generatePDF(id) {
      console.log("Amila");
    
    try {
      const { data} = await  axios.get('/istockissue/view?id='+id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.alldata = data.alldata
       this.all_code = data.all_code
        this.details = data.details
        this.total = data.total
     
      
    } catch (error) {
      console.log(error.response);
    }


    const doc = new jsPDF();

function addPageBorders(doc) {
const pageWidth = doc.internal.pageSize.width;
const pageHeight = doc.internal.pageSize.height;

// Set the border style
doc.setDrawColor(71, 144, 255); // Black color
doc.setLineWidth(15); // Border width

// Draw a line at the top of the page
doc.line(0, 0, pageWidth, 0);
// Draw a line at the bottom of the page
doc.line(0, pageHeight, pageWidth, pageHeight);
}
// Update this with your image URL or file path

var img = new Image()
img.src = '/img/evenware-logo.png'
const imageWidth = doc.internal.pageSize.getWidth() - 550; // Adjust 20 if you need margins
const imageHeight = (imageWidth * 3) / 4; // Assuming the aspect ratio is 4:3, adjust as needed

doc.addImage(img, 'png', 10, 13, imageWidth, imageHeight);
doc.setFontSize(18);
doc.setFont('Helvetica', 'bold');
doc.text('Consignment GIN', 105, 30, null, null, 'center');
doc.setFontSize(12);

doc.text('Demonstration System', 10, 45, null, null);

doc.setFont('Helvetica', 'normal');
doc.setFontSize(8);
doc.text('No 08, Rodrigo Mawatha,', 10, 48, null, null);
doc.text('Nawala Road,', 10, 51, null, null);
doc.text('Rajagiriya,', 10, 54, null, null);
doc.text('Colombo 08,', 10, 57, null, null);
doc.text('Sri Lanka', 10, 60, null, null);
doc.text('Tel : 0112 806 776-9,', 10, 63, null, null);
doc.text('Web : colombo@cmc.slt.lk ,', 10, 66, null, null);


doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('GIN To:', 85, 45, null, null);
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.alldata.relatedToCustomer.C_name, 85, 48, null, null);
doc.text(this.alldata.relatedToCustomer.C_address_line1, 85, 51, null, null);
doc.text(this.alldata.relatedToCustomer.C_address_line2, 85, 54, null, null);
doc.text(this.alldata.relatedToCustomer.C_address_line3, 85, 57, null, null);







doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('GIN No:', 200, 45, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.alldata.SI_issueNum, 200, 49, null, null, 'right');


doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('SO Code:', 200, 53, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.alldata.relatedToSo.so_code, 200, 56, null, null, 'right');

doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Sales Person:', 200, 60, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.alldata.relatedToSalesPerson.name, 200, 63, null, null, 'right');






doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Date:', 200, 67, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.alldata.issues_date, 200, 70, null, null, 'right');

const tableData = [
  ['No', 'Product Code', 'Product Description',  'Qty', 'Bin Location']
];


this.details.forEach(detail => {
  tableData.push([
      detail.no,
      detail.p_code,
      detail.P_description,
    
      { content: detail.qty, styles: { halign: 'right' } },
      detail.bin_location,
     
   
     
     
     
    
  ]);
});

  // Add table to the PDF
  doc.autoTable({
        startY: 85, // Y position to start the table
        head: [tableData[0]], // Table header
        body: tableData.slice(1),
        addPageContent: function(data) {
    addPageBorders(doc); // Call the function to add page borders
},
styles: {
    font: 'Helvetica',
    fontSize:8,
},
      // Table data excluding header
  });

  
  const tableBottomY = doc.lastAutoTable.finalY;

  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Sub Total: '+this.total.total_line_amount, 195, tableBottomY+10, null, null, 'right');

  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Special Discount: '+this.total.special_discount, 195, tableBottomY+18, null, null, 'right');

  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Total :'+this.total.sub_total, 195, tableBottomY+26, null, null, 'right');

  doc.setFontSize(9);
    doc.setFont('Helvetica', 'normal');
  doc.text('* Cheques should be drawn in favour of “JANATHA AUTOMOBILES (PVT) LTD” & crossed A/C payee only.', 10, tableBottomY+50, null, null);
  doc.text('* Settlement should be made within 5 days', 10, tableBottomY+55, null, null);
  doc.text('* Any complaints should be informed within 3 days after receiving the goods.', 10, tableBottomY+60, null, null);
  doc.text('* Complaints after 3 days will not be accepted under any circumstances.', 10, tableBottomY+65, null, null);
  doc.text('* Bank Details : Commercial Bank (7056), Old Moor Street Branch (017), A/C No. 100 039 2638. ', 10, tableBottomY+70, null, null);
  doc.text('* The above Invoice is inclusive of all taxes.', 10, tableBottomY+75, null, null);
  



  doc.output('dataurlnewwindow');




  },




  async Confirm(id) {
       
   
       try {
         const { data} = await  axios.get('/istockissue/confirm?id='+id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadGin();
           
            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },
     
  async Confimmodel(id){
        this.infoModal1.content = id;
       this.$root.$emit('bv::show::modal', this.infoModal1.id);
      
      },

  ViewLoad(id) {
    
    this.$router.push('/gin/viewcon?id='+id);
  },
  updateLoad(id) {
    
    
    this.$router.push('/gin/update?id='+id);
  },
   Viewpage(id) {
  
  this.$router.push('/gin/viewcon?id='+id);
 
},
async Createinvoice(id){
        this.$router.push('/sinvoice/createsoinvoicecon?id='+id);
      },



  async info(idgin) {
  
  try {
    const { data} = await  axios.get('/istockissue/view?id='+idgin,{
      headers:{
        'Authorization':'Bearer '+this.access_token,
        'Content-type': 'application/json',
       
      }
     });
     console.log(data);
     this.infoModal.content = data.gin
     this.$root.$emit('bv::show::modal', this.infoModal.id)
    
    
  } catch (error) {
    console.log(error.response);
  }
},

  serchCustom(id) {

this.filterOn = id;
  },

  onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
  
  async loadGin() {
    console.log(this.access_token);
    try {
      const { data} = await  axios.get('/istockissue/indexcon',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.igins = data.all_data;
       this.totalRows = this.igins.length;
       this.isLoading = false; 
      
    } catch (error) {
      console.log(error.response);
    }
  },
   

       


 
  


 


},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style scoped>
.modal-footer{
    text-align: right !important;
    display: block;
  }
</style>